<template>
  <d-modal
    class="patients-form-decisions"
    style="background-color: rgba(0,0,0,0.6)!important;" >
    <button
      @click.prevent="onClosePopup"
      :class="['mr-1', 'decisions-close-button', show ? 'decisions-close-button-load' : 'decisions-close-button-hidden']">
      <i class="material-icons">close</i>
    </button>
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja informacji</template>
          <template v-else>Dodawanie informacji</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
      <validation-observer
        v-if="!loadError"
        ref="patients-form-information"
        tag="form">
        <div v-for="(information, indexInformation) in templateNew" :key="'information-' + indexInformation">
          <div class="form-group decision-box" v-if="information.type === 'input'">
            <label class="title-box" :for="information.name">
              {{information.label}}
            </label>
            <validation-provider
              :name="information.name"
              v-slot="{ errors }">
              <d-input
                :type="'text'"
                :state="errors.length ? 'invalid' : null"
                v-model="information.value"
              />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <p class="decision-note" v-if="information.text">{{information.text}}</p>
          </div>
          <div class="form-group decision-box" v-if="information.type === 'date'">
            <label class="title-box" :for="information.name">
              {{information.label}}
            </label>
            <validation-provider
              :name="information.name"
              v-slot="{ errors }">
              <date-picker
                v-model="information.value"
                valueType="format"
                class="mr-2"
                style="width: 100%"
              />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <p class="decision-note" v-if="information.text">{{information.text}}</p>
          </div>
          <div class="form-group decision-box" v-if="information.type === 'textarea'">
            <label class="title-box" :for="information.name">
              {{information.label}}
            </label>
            <validation-provider
              :name="information.name"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true }">
                 <textarea
                   :type="'text'"
                   :state="errors.length ? 'invalid' : null"
                   v-model="information.value"
                 ></textarea>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <p class="decision-note" v-if="information.text">{{information.text}}</p>
          </div>
          <div class="form-group decision-box" v-if="(information.type === 'select') && (information.multiselect === 0)">
            <validation-provider
              :name="information.name"
              v-slot="{ errors }">
              <label class="title-box" :for="information.name">{{information.label}}</label>
              <div :class="{ 'form-control': true, 'is-select': true }">
                <v-select
                  :options="information.possibleValues"
                  v-model="information.value"
                  :reduce="boss => boss.id"
                  label="id">
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }}
                    </div>
                  </template>
                </v-select>
              </div>
              <p class="decision-note" v-if="information.text">{{information.text}}</p>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div class="form-group decision-box" v-if="(information.type === 'select') && (information.multiselect === 1) && (information.specializations === true)">
            <validation-provider
              :name="information.name"
              v-slot="{ errors }">
              <label class="title-box" :for="information.name">{{information.label}}</label>
              <multi-select
                :multiple="true"
                :ref="'multi-user-list'"
                placeholder="Wybierz..."
                :options="information.possibleValues"
                @input="getValueFromMultiSelect(information.value)"
                v-model="information.value"
                :track-by="'id'"
                label="name"
                select-label="Wybierz"
                deselectLabel="Usuń wybór"
                selectedLabel="Wybrane"
                :taggable="true"
              />
              <p class="decision-note" v-if="information.text">{{information.text}}</p>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <div class="form-group" style="display: none">
              <pre>{{usersList}}</pre>
              <pre>{{data.specialization}}</pre>
              <pre>{{specialization}}</pre>
            </div>
            <div class="form-group under-box" :key="userKey" v-if="usersList.length  && information.specializations === true">
              <label class="title-box" :for="information.name">Specjalizacje zespołu</label>
              <div class="form-group" v-for="(user, index) in usersList" :key="index">
                <span>
                  <i class="material-icons text-success mr-2">chevron_right</i>
                  <label for="name" class="mr-4 mt-1">
                    {{user.name}}
                  </label>
                  <validation-provider
                    rules="required"
                    :name="'specializationsNew'"
                    v-slot="{ errors }">
                    <div :class="{ 'form-control': true, 'is-select': true }">
                      <v-select
                        :options="specializationsNew"
                        @input="pushIdAndSpecialization(user.id, data.specialization[index], index)"
                        :reduce="boss => boss.id"
                        v-model="data.specialization[index]"
                        label="id">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </span>
              </div>
            </div>
          </div>
          <div class="form-group decision-box" v-if="(information.type === 'select') && (information.multiselect === 1) && (information.specializations === false)">
            <validation-provider
              :name="information.name"
              v-slot="{ errors }">
              <label class="title-box" :for="information.name">{{information.label}}</label>
              <multi-select
                :multiple="true"
                placeholder="Wybierz..."
                :options="information.possibleValues"
                v-model="information.value"
                :track-by="'id'"
                label="name"
                select-label="Wybierz"
                deselectLabel="Usuń wybór"
                selectedLabel="Wybrane"
                :taggable="true"
              />
              <p class="decision-note" v-if="information.text">{{information.text}}</p>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div class="form-group decision-box" v-if="information.type === 'checkbox'">
            <d-checkbox
              :value="'1'"
              :unchecked-value="'0'"
              v-model="information.value"
              :class="'mb-3'"
              toggle>
              <span class="title-box">{{information.label}}</span>
            </d-checkbox>
            <p class="decision-note" v-if="information.text">{{information.text}}</p>
          </div>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="onClosePopup">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div v-if="!templatesList" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FilterSelect from '@/components/others/FilterSelect';
import DatePicker from 'vue2-datepicker';
import multiSelect from 'vue-multiselect'
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'patients-form-information-popup',
  components: { FilterSelect, DatePicker, multiSelect },
  props: {
    informationId: {
      default: 0,
      type: Number
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    show: {
      default: false,
      type: Boolean
    },
    patientId: {
      required: true,
      type: Number
    },
    visitId: {
      default: 0,
      type: Number
    }
  },
  computed: {
    informationGet () {
      return this.$store.getters.getPatientsInformationData
    },
    specializationGet () {
      return this.$store.getters.getPatientsSpecializationData
    },
    isEdit () {
      return !!this.informationId;
    },
  },
  watch: {
    'getJson': function () {
      setTimeout(() => {
        this.templateNew = this.informationGet;
        this.specializationsNew = this.specializationGet;
      }, 500)
    }
  },
  data() {
    return {
      data: {
        id: '',
        name: '',
        patient_id: '',
        data_fields: [],
        specialization: []
      },
      templatesList: [],
      template: [],
      templateNew: [],
      institutions: [],
      templateEdit: [],
      informationEdit: [],
      specializationsNew: [],
      usersList: [],
      specialization: [],
      getJson: 0,
      userKey: 0,
      templateListLoad: false,
      loadError: false
    };
  },
  mounted () {
    Vue.nextTick(() => {
      if (this.isEdit) {
        this.getInformationItem();
      } else {
        this.patientsInformationGet();
      }
    })
  },
  methods: {
    getValueFromMultiSelect(value) {
      this.usersList = value;
    },
    getValueFromMultiSelectEdit() {
      setTimeout(() => {
        for (let i = 0; i < this.specialization.length; i++) {
          if (this.$refs['multi-user-list'][i]) {
            if (this.$refs['multi-user-list'][i].internalValue.length) {
              const refValue = this.$refs['multi-user-list'][i].internalValue;
              for (let j = 0; j < refValue.length; j++) {
                this.usersList[j] = {
                  id: refValue[j].id,
                  name: refValue[j].name
                };
                this.data.specialization.push(refValue[j].specialization);
              }
            }
          }
        }
        this.userKey += 1;
      }, 500);
    },
    pushIdAndSpecialization(value, special, index) {
      this.specialization[index] = {
        id: value,
        specialization: special
      }
    },
    getInformationItem () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/diagnosis-information/item/' + this.informationId,
        outputKey: 'informationEdit',
        errorKey: 'loadError',
        params: {
          pagination: false
        },
        successAction: () => {
          setTimeout(() => {
            this.templateNew = this.informationEdit.data_fields;
            this.data.patient_id = this.informationEdit.patient_id;
            this.data.id = this.informationEdit.id;
            this.specialization = this.informationEdit.specialization;
            this.specializationsNew = this.informationEdit.specializations;
            this.getValueFromMultiSelectEdit()
          }, 200)
        }
      });
    },
    setImage(event) {
      this.data.scan_file = event.target.files[0];
    },
    patientsInformationGet () {
      this.$store.dispatch('patientsInformationGet');
      this.getJson += 1;
    },
    validateForm () {
      FormUtils.validate(this.$refs['patients-form-information'], this.submitForm);
    },
    submitForm  () {
      let imageFields = false;
      let formDataToSend = {
        patient_id: this.patientId,
        data_fields: this.templateNew,
        specialization: this.specialization,
        id: this.data.id,
        visit_id: this.visitId
      };
      let endpointUrl = this.isEdit ? '/patients/diagnosis-information/update/' + this.informationId : '/patients/diagnosis-information/store';
      FormUtils.submit(this, {
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano informacje',
        successText: 'Wybrana informacja została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje informacji nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.onSubmitCallback();
          this.onClosePopup();
        }
      }, imageFields);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  @import '../../../assets/scss/patients-form-decisions.scss';
</style>
